import SunriseImage from '@/assets/sunrise.png';
import SunsetImage from '@/assets/sunset.png';
import AppIntroVideo from '@/assets/videos/app/app-intro.webm';
import AppIntroVideoPoster from '@/assets/app-intro-vid-thumb.png';
import { AboutHamdBox } from '@/components/home/AboutHamdBox';
import { SuggestedExerciseBox } from '@/components/home/SuggestedExerciseBox';
import { TraumaBox } from '@/components/home/TraumaBox';
import { EmotionPicker } from '@/components/ChildSession/EmotionPicker';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { Carousel } from "@/components/ui/carousel";
import { Overlay } from '@/components/ui/overlay';
import VideoPlayer from '@/components/ui/video-player';
import { getRandomSuggestedExercises, PSYCHOEDUCATION_VIDEOS } from '@/lib/data/contentCatalog';
import { getTimePeriod } from '@/lib/utils/timePeriod';
import { createFileRoute } from "@tanstack/react-router";
import { motion } from "framer-motion";
import { useState, useMemo } from 'react';
import { FormattedMessage, useIntl } from "react-intl";


export const Route = createFileRoute("/(content)/children/exercises/")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: "Exercises - HAMD" }],
  }),
  beforeLoad: () => ({
    title: "content.title",
    navbar: {
      showTitle: false,
      languageSwitcher: false,
      onBack: false,
      transparent: true,
    },
  }),
});


function Reveal({
  children,
  delay = 0,
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}

const timePeriod = getTimePeriod()

const isMorning = timePeriod === 'morning'
const isAfternoon = timePeriod === 'afternoon'
const isEvening = timePeriod === 'evening'


function RouteComponent() {
  const intl = useIntl();
  const [openVideoId, setOpenVideoId] = useState<string | null>(null);
  const [isIntroVideoOpen, setIsIntroVideoOpen] = useState(false);

  // Get random suggested exercises (changes between sessions)
  const suggestedExercises = useMemo(() => {
    return getRandomSuggestedExercises('child', 2).map(exercise => ({
      titleKey: exercise.titleKey,
      contentKey: exercise.descriptionKey || exercise.titleKey,
      to: `/children/exercises/${exercise.id}`
    }));
  }, []);

  return (
    <main
      className="space-y-7.5  overflow-hidden select-none"
    >

      <section className='px-4 relative pb-2' >
        {isMorning
          ? <div style={{
            background: "linear-gradient(197.12deg, rgba(60, 199, 254, 0.25) 4.55%, rgba(236, 229, 226, 0) 45.18%)"
          }} className='w-full h-32 absolute -top-2.5 -right-2.5   z-10' />
          : isAfternoon
            ? <div style={{
              background: "linear-gradient(197deg, rgba(252, 178, 60, 0.28) 4.55%, rgba(236, 229, 226, 0) 45.18%)"
            }} className='w-full h-32 absolute -top-2.5 -right-2.5   z-10' />
            : isEvening
            ? <div style={{
              background: "linear-gradient(197deg, rgba(77, 55, 188, 0.35) 1.55%, rgba(236, 229, 226, 0) 45.18%)"
            }} className='w-full h-32 absolute -top-2.5 -right-2.5   z-10' />
            : <div style={{
              background: "linear-gradient(197deg, rgba(40, 28, 110, 0.45) 1.55%, rgba(236, 229, 226, 0) 45.18%)"
            }} className='w-full h-32 absolute -top-2.5 -right-2.5   z-10' />
        }

        <div className='pt-4 flex  justify-end relative z-30'>
          <LanguageSwitcher className="w-9 h-9" />
        </div>
        <div className="flex w-full justify-between items-end -mt-5 relative z-20">
          <div>
            <h1 className="text-hero text-gray">
              <FormattedMessage
                id={
                  isMorning
                    ? "greeting.goodMorning"
                    : isAfternoon
                      ? "greeting.goodAfternoon"
                    : isEvening
                      ? "greeting.goodEvening"
                      : "greeting.goodNight"
                }
                defaultMessage={
                  isMorning
                    ? "Good Morning"
                    : isAfternoon
                      ? "Good Afternoon"
                    : isEvening
                      ? "Good Evening"
                      : "Good Night"
                }
              />
            </h1>
            <h1 className="text-hero text-black">
              <FormattedMessage id="greeting.friend" defaultMessage="Friend" />
            </h1>
          </div>
          {isMorning || isAfternoon
            ? <img src={SunriseImage} alt="" className="max-w-13 w-13 mr-2" />
            : <img src={SunsetImage} alt="" className="max-w-17.5 w-17.5 h-16.5 mr-2" />
          }
        </div>
      </section>

      {/* ABOUT */}
      {/* <section className="px-4">
        <Reveal>
          <AboutHamdBox
            audience='child'
            onClick={() => setIsIntroVideoOpen(true)}
          />
        </Reveal>
      </section> */}
{/* 
      <section className="space-y-4">
        <Reveal>
          <h2 className="px-4 text-h3 text-black font-medium">
            <FormattedMessage id="exercises.suggestedForYou" defaultMessage="Suggested for you" />
          </h2>
        </Reveal>

        <div className="px-2">
          <Carousel
            items={suggestedExercises.map((item, index) => (
              <Reveal key={index} delay={index * 0.1}>
                <SuggestedExerciseBox
                  {...item}
                  audience='child'
                />
              </Reveal>
            ))}
            itemsPerView={1}
            dotActiveColor="bg-primary"
            dotInactiveColor="bg-soft-beige"
          />
        </div>
      </section> */}

      {/* TRAUMA */}
      {/* <section className="space-y-4">
        <Reveal>
          <h2 className="px-4 text-h3 text-black font-medium">
            <FormattedMessage id="exercises.learnAboutTrauma" defaultMessage="Learn About Trauma" />
          </h2>
        </Reveal>

        <div className="px-2">
          <Carousel
            items={PSYCHOEDUCATION_VIDEOS.map((item, index) => (
              <Reveal key={index} delay={index * 0.08}>
                <div onClick={() => setOpenVideoId(item.id)}>
                  <TraumaBox
                    audience='child'
                    title={intl.formatMessage({ id: item.titleKey })}
                    content={intl.formatMessage({ id: item.descriptionKey })}
                    duration={item.duration}
                    subDescription={intl.formatMessage({ id: "exercises.learnAboutTrauma.subDescription" })}
                  />
                </div>
              </Reveal>
            ))}
            itemsPerView={2}
            padding="px-2"
            dotActiveColor="bg-soft-beige"
            dotInactiveColor="bg-primary"
          />
        </div>

        {PSYCHOEDUCATION_VIDEOS.map((item) => (
          <Overlay
            key={item.id}
            show={openVideoId === item.id}
            onClose={() => setOpenVideoId(null)}
            className="max-w-4xl"
            fullHeight
            hideCloseButton={true}
          >
            <div className="flex justify-center relative h-full">
              <VideoPlayer
                sources={item.videoSources}
                src={item.videoSrc}
                poster={item.poster}
                autoPlay
                className="w-full h-full"
                onBack={() => setOpenVideoId(null)}
              />
            </div>
          </Overlay>
        ))}
      </section> */}

      {/* SYMPTOMS — replaced with EmotionPicker */}
      <section className="space-y-4">
        <EmotionPicker embedded />
      </section>

      {/* INTRO VIDEO */}
      {/* <Overlay
        show={isIntroVideoOpen}
        hideCloseButton={true}
        onClose={() => setIsIntroVideoOpen(false)}
        className="max-w-4xl"
        fullHeight
      >
        <div className="relative h-full">
          <VideoPlayer
            src={AppIntroVideo}
            poster={AppIntroVideoPoster}
            autoPlay
            className="w-full h-full"
            onBack={() => setIsIntroVideoOpen(false)}
          />
        </div>
      </Overlay> */}

    </main>
  );
}









